module.exports = __webpack_public_path__ + "media/assets/faria_products/PREMIUM_SUPPORT-648843b6afaabab4d5840cec26ffafff172f6a33f7f079054b1ced74acad15fb.png";